import { render } from "./OtiClock.vue?vue&type=template&id=259c584a&scoped=true"
import script from "./OtiClock.vue?vue&type=script&lang=js"
export * from "./OtiClock.vue?vue&type=script&lang=js"

import "./OtiClock.vue?vue&type=style&index=0&id=259c584a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259c584a"]])

export default __exports__